/**
 * @generated SignedSource<<7728b06e73a44858bfcbf584a90a3573>>
 * @relayHash 1f87220f74afe487512a588e576af175
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b6a830eeabb97464063c2c289e338fdf304261a3d157e9505061f5e4fc1bbeca

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ListQuery } from './ListQuery.graphql';

import isInitialiseVirtualiserStateFromRelayStoreEnabled_provider from '@atlassian/jira-relay-provider/src/initialise-virtualiser-state-from-relay-store.relayprovider';
import isJiraItrM4Exp3Enabled_provider from '@atlassian/jira-relay-provider/src/is-jira-itr-m4-exp-3-enabled.relayprovider';
import isJscIFCEnabled_provider from '@atlassian/jira-relay-provider/src/is-jsc-ifc-enabled.relayprovider';
import isSingleLineEventDelegatorEnabled_provider from '@atlassian/jira-relay-provider/src/is-single-line-event-delegator-enabled.relayprovider';
import isJiraSingleLineRowHeightEnabled_provider from '@atlassian/jira-relay-provider/src/is-single-line-row-height-enabled.relayprovider';
import isFieldsByIdRemoved_provider from '@atlassian/jira-relay-provider/src/issue-view-dfo-remove-fields-by-id.relayprovider';
import isJiraConfluencePageContentEnabled_provider from '@atlassian/jira-relay-provider/src/jira-confluence-page-content-enabled.relayprovider';
import isIssueRealtimeExtractionEnabled_provider from '@atlassian/jira-relay-provider/src/jira-issue-realtime-extraction.relayprovider';
import isNumberFieldConfigurableEnabled_provider from '@atlassian/jira-relay-provider/src/jira-number-field-configuration-enabled.relayprovider';
import isJiraTimelineAnalyticsHarmonizationEnabled_provider from '@atlassian/jira-relay-provider/src/jira-timeline-analytics-harmonization.relayprovider';
import isQueryByStatusFieldDirectlyEnabled_provider from '@atlassian/jira-relay-provider/src/jiv-20953-query-by-status-field-directly.relayprovider';
import isJSCAliasChangesEnabled_provider from '@atlassian/jira-relay-provider/src/jsc-alias-changes.relayprovider';
import isJscInlineEditRefactorEnabled_provider from '@atlassian/jira-relay-provider/src/jsc-inline-editing-field-refactor.relayprovider';
import isJscInlineEditFlagFixEnabled_provider from '@atlassian/jira-relay-provider/src/jsc-inline-editing-flag-fix.relayprovider';
import isJscM2Enabled_provider from '@atlassian/jira-relay-provider/src/jsc-m2-fe-changes.relayprovider';
import isJscMergedColumnEnabled_provider from '@atlassian/jira-relay-provider/src/jsc-merged-column.relayprovider';

const node: PreloadableConcreteRequest<ListQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "b6a830eeabb97464063c2c289e338fdf304261a3d157e9505061f5e4fc1bbeca",
    "metadata": {},
    "name": "ListQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider": isJscIFCEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider": isJSCAliasChangesEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissuerealtimeextractionrelayprovider": isIssueRealtimeExtractionEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider": isInitialiseVirtualiserStateFromRelayStoreEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider": isJscM2Enabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider": isJscMergedColumnEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider": isJiraItrM4Exp3Enabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiv20953querybystatusfielddirectlyrelayprovider": isQueryByStatusFieldDirectlyEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider": isJiraTimelineAnalyticsHarmonizationEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider": isJscInlineEditRefactorEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider": isJscInlineEditFlagFixEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider": isJiraSingleLineRowHeightEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider": isSingleLineEventDelegatorEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider": isFieldsByIdRemoved_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": isNumberFieldConfigurableEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider": isJiraConfluencePageContentEnabled_provider
    }
  }
};

export default node;
